import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './containers/Home/Home.js';
import Washdryfold from './containers/Washdryfold/Washdryfold.js';
import reportWebVitals from './reportWebVitals';
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import Orders from './containers/Orders/Orders.js';
import Login from './containers/Login/Login.js';
import Trackorder from './containers/Trackorder/Trackorder.js';
import Survey from './containers/survey/Survey.js';
import Uat from './containers/Uat/Uat.js';
import Orderdetails from './containers/Orderdetails/Orderdetails.js';
import Washdryiron from './containers/Washdryiron/Washdryiron.js';
import Ironfoldonly from './containers/Ironfoldonly/Ironfoldonly.js';
import Pricelist from './containers/Pricelist/Pricelist.js';
import Dashboard from './containers/Dashboard/Dashboard.js';
import UserProfile from './containers/UserProfile/UserProfile.js';
import Tools from './containers/Tools/Tools.js';

const UrlNav = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact={true} path="/" element={<Login />}>
        </Route>
        <Route exact={true} path="/home" element={<Home />}>
        </Route>
        <Route exact={true} path="/washdryfold" element={<Washdryfold JB='' />}>
        </Route>
        <Route exact={true} path="/orders" element={<Orders />}>
        </Route>
        <Route exact={true} path="/trackorder" element={<Trackorder />}>
        </Route>
        <Route exact={true} path="/survey" element={<Survey />}>
        </Route>
        <Route exact={true} path="/orderdetails" element={<Orderdetails />}>
        </Route>
        <Route>
          <Route exact={true} path="/washdryiron" element={<Washdryiron />}></Route>
        </Route>
        <Route>
          <Route exact={true} path="/ironfoldonly" element={<Ironfoldonly />}></Route>
        </Route>
        <Route exact={true} path="/pricelist" element={<Pricelist />}>
        </Route>
        <Route>
          <Route exact={true} path="/uat" element={<Uat />}></Route>
        </Route>
        <Route>
          <Route exact={true} path="/dashboard" element={<Dashboard />}></Route>
        </Route>
        <Route>
          <Route exact={true} path="/userprofile" element={<UserProfile />}></Route>
        </Route>
        <Route>
          <Route exact={true} path="/tools" element={<Tools />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );

};

const container = document.getElementById('root');
  // Add this to your src/index.js file
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
       // .then(reg => console.log('Service Worker registered successfully:', reg))
       // .catch(err => console.error('Service Worker registration failed:', err));
    });
  }
const root = createRoot(container);

root.render(<UrlNav />);